import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {},
    isLogin: false,
    userPremise: []
  },
  getters: {},
  mutations: {
    changeIsLogin(state, val) {
      state.isLogin = val.login;
    },
    setUserPremise(state, val) {
      state.userPremise = val.rolesList;
    },
    setUserInfo(state, val) {
      state.userInfo = val.userInfo;
    },
  },
  actions: {},
  modules: {},
});
